import OperationRepository from '@/libs/customAxios/operationAxios'

const layoutSettingResource = '/merchant/settings/layout'

export default {
  getWaybillLayout() {
    return OperationRepository.get(`${layoutSettingResource}/waybill`)
  },
  getActiveWaybillLayout() {
    return OperationRepository.get(`${layoutSettingResource}/waybill/active`)
  },
  getWaybillLayoutDetail(id) {
    return OperationRepository.get(`${layoutSettingResource}/waybill/${id}`)
  },
}
